import styled from "styled-components"
import PageTopTitle from "../../components/shared/PageTopTitle"
import { useDispatch, useSelector } from "react-redux"
import { useEffect, useState } from "react"
import Pagination from "../../components/shared/Pagination"
import { getAdminCompanyLoadFilter, resetSingleShipmentLoadItem, setCompleteShipmentIds } from "../../features/loadList/loadListSlice"
import ItemContainer from "../../components/topList/yuklemedeList/item/ItemContainer"
import ItemContainerWide from "../../components/topList/yuklemedeList/item/ItemContainerWide"
import SmallSpinner from "../../components/shared/spinners/SmallSpinner"
import TopPagesMap from "../../components/topPagesMap/TopPagesMap"
import { resetAllState } from "../../features/topPagesMap/topPagesMapSlice"
import useWindowDimensions from "../../hooks/useWindowSize"
import ItemMobileContainer from "../../components/topList/yuklemedeList/item/ItemMobileContainer"
import YuklemeListTopContainer from "../../components/topPages/topContainer/YuklemeListTopContainer"
import InputSelectLoadListFilter from "../../components/shared/input/special/InputSelectLoadListFilter"
import CollapsibleTopMap from "../../components/topPages/CollapsibleTopMap"
import ShipmentBulkActions from "../../components/topPages/ShipmentBulkActions"
import usePageShipmentSelection from "../../hooks/usePageShipmentSelection"
import { showModal } from "../../features/modal/modalSlice"

const Container = styled.div`
.wrapper{
    display: flex;
    flex-direction: column;
    width: 100%;

    .content{
        gap: 60px;
        margin: 0 30px;
        margin-top: 20px;
        .top-filter-admin{
            display: flex;
            align-items: center;
            justify-content: flex-end;
            width: 100%;
            margin-block: 20px;
        }
            .loading{
                min-height: 30vh;
                display: flex;
                align-items: center;
                justify-content: center;
            }
    }

    .pagination-container{
        gap: 60px;
        margin: 0 30px;
        margin-top: 20px;
        height: 200px;
    }
}
 
`
const YuklemedeList = () => {
    const storage = JSON.parse(localStorage.getItem("isRemember")) ? localStorage : sessionStorage;
    const rld = JSON.parse(storage.getItem("rld"))
    const {yuklemedeList, yuklemedeListQuantity, isLoadingYuklemedeList, loadItemSelect, selectedLoadListCompany, loadListCompanyList} = useSelector(state => state.loadList)

    const {windowDimensions} = useWindowDimensions()
    
    const [activeItemId, setActiveItemId] = useState(null)
    const [isMapOpen, setIsMapOpen] = useState(false)

    const [currentPage, setCurrentPage] = useState(1)

    const dispatch = useDispatch()
    const {selectedShipmentIds, toggleShipment, selectAllOnPage, clearSelection, allPageSelected} = usePageShipmentSelection(yuklemedeList)

    const openCompletePermission = () => {
        dispatch(setCompleteShipmentIds(selectedShipmentIds))
        dispatch(showModal("completeShipmentsPermission"))
    }

    // useEffect(() => {
    //     // Sayfa yüklendiğinde en üste kaydır
    //     window.scrollTo(0, 0);
    // }, []);

    const itemsPerPage = 20
    const totalPages = Math.ceil(yuklemedeListQuantity / itemsPerPage);

    useEffect(() => {
        const matchedItem = yuklemedeList.find(item => item.waitinLoadId === loadItemSelect);
        if (matchedItem) {
          const element = document.getElementById(matchedItem.id);
          
          if (element) {
            const navbarHeight = 255;
            const elementPosition = element.getBoundingClientRect().top + window.scrollY;
      
            window.scrollTo({
              top: elementPosition - navbarHeight,
              behavior: "smooth"
            });
          }
         }else{
            window.scrollTo(0, 0);
         }
       }, [loadItemSelect, yuklemedeList]);

       useEffect(() => {
        if(rld === "db7bb061-0f64-4eae-9c4f-678a7359fd01" || rld === "f84f35ab-0eb1-46a4-84f4-e72b236c3d26" || rld === "a7b53ef7-1cf6-4720-9b13-d9f81b5a0f99"){
            dispatch(getAdminCompanyLoadFilter())
        }
      },[])

       useEffect(()=> {

        return () => {
            dispatch(resetAllState())
            dispatch(resetSingleShipmentLoadItem())
         }

       },[])
       
  return (
    <Container>
        <div className="wrapper">
            <PageTopTitle title={"Yüklemede"} position="sticky"/>
            <div className="content">
            <CollapsibleTopMap isOpen={isMapOpen} onToggle={() => setIsMapOpen(open => !open)}>
                <TopPagesMap/>
            </CollapsibleTopMap>
                {"db7bb061-0f64-4eae-9c4f-678a7359fd01" === rld &&
                    <div className="top-filter-admin">
                        <InputSelectLoadListFilter data={selectedLoadListCompany} labelText={"Firma Adı"} inputWidth={"300px"} initialOptions={loadListCompanyList} name={"selectedLoadListCompany"} />
                    </div>
                }
                <YuklemeListTopContainer currentPage={currentPage}/>
                {selectedShipmentIds.length > 0 && (
                    <ShipmentBulkActions
                        selectedCount={selectedShipmentIds.length}
                        allPageSelected={allPageSelected}
                        onClear={clearSelection}
                        onSelectAll={selectAllOnPage}
                        onComplete={openCompletePermission}
                    />
                )}
                {isLoadingYuklemedeList ? (
                    <div className="loading">
                        <SmallSpinner size={"65px"} color={"#fff"} bgColor={"#E85446"} />
                    </div>
                    ) : (
                    <>
                        {yuklemedeList?.map((item, i) => {
                            const width = windowDimensions?.width;
                            const isActive = item.id === activeItemId;

                            let ItemComponent;
                            if (width < 850) {
                                ItemComponent = ItemMobileContainer; 
                            } else if (width < 1150 || isActive) {
                                ItemComponent = ItemContainerWide;
                            } else {
                                ItemComponent = ItemContainer;
                            }
                            return (
                                <ItemComponent
                                    key={i}
                                    item={item} 
                                    setActiveItemId={setActiveItemId} 
                                    activeItemId={activeItemId}
                                    isSelected={selectedShipmentIds.includes(item.id)}
                                    onSelectionChange={toggleShipment}
                                    onShowMap={() => setIsMapOpen(true)}
                                />
                            );
                        })}
                    </>
                    )
                }
            </div>
            <div className="pagination-container">
            {
                yuklemedeList?.length > 0 &&   
                <Pagination totalPages={totalPages} handleClick={setCurrentPage} currentPage={currentPage}/>
            }
        </div>
        </div>
    </Container>
  )
}

export default YuklemedeList
